import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavBaseService } from 'ui-ionic-comp';

@Injectable({
  providedIn: 'root'
})
export class NavService extends NavBaseService {

  // App directory route
  public appDir = '/';

  // Definition of the routes
  public routes = {
    home: `${this.appDir}/home`,
    drafts: (organizationId: string) => `${this.appDir}/organizations/${organizationId}/drafts`,
    draft: (organizationId: string, draftId: string) => `${this.appDir}/organizations/${organizationId}/drafts/${draftId}`,
    settings: `${this.appDir}/settings`,
    signIn: `${this.appDir}/auth/signin`,
    signUp: `${this.appDir}/auth/signup`,
    userProfile: `${this.appDir}/user/profile`,
  };

  constructor(private _router: Router) {
    super(_router)
  }
}
